module.exports = __webpack_public_path__ + "img/www.bd74cd27.svg";